import ItemDetailPage from './ItemDetailPage.container'

export default ItemDetailPage
